// Bouwt de stappenlijst van het invulscherm.
//
// Eén pure helper bepaalt de reeks stappen; de orchestrator
// (QuestionnaireOpen) mapt alleen nog index → stap. Skip-regels staan dus
// nergens als losse `if` in een stapcomponent.
// AI-CONTEXT: See docs/patterns.md#flow-step-skip-via-pure-helper
//
// Met gamificatie aan wordt elke sectievraag een eigen stap: de mini-game
// animaties kunnen niet draaien met een hele sectie op één pagina. Uit blijft
// een sectie één pagina met al zijn vragen.
//
// Conditionele vragen zijn hier al uit: de aanroeper geeft de door
// filterFieldsForResponses gefilterde lijst mee.
// AI-CONTEXT: See docs/features/conditional-questions.md

import sortSectionFields from './sortSectionFields'

/**
 * @param {Array<object>} topLevelFields - Zichtbare velden met `SectionID === ''`,
 *   in weergavevolgorde (sectiemarkeringen en losse vragen door elkaar)
 * @param {Array<object>} allFields - Alle zichtbare velden, om sectievragen te vinden
 * @param {boolean} gamificationEnabled - Staat de mini-game aan?
 * @returns {Array<object>} De stappen, in volgorde. Sectievragen dragen bij
 *   gamificatie een `_section` mee met de titel en kleur van hun sectie.
 */
const buildNavItems = (topLevelFields, allFields, gamificationEnabled) => {
    if (!Array.isArray(topLevelFields)) return []
    // Zelfde referentie terug: scheelt een rerender per toetsaanslag op
    // vragenlijsten zonder regels.
    if (!gamificationEnabled) return topLevelFields

    const out = []
    topLevelFields.forEach((item) => {
        if (item?.Type !== 'section') {
            out.push(item)
            return
        }
        sortSectionFields((allFields || []).filter((child) => child?.SectionID === item.ID))
            .forEach((child) => out.push({
                ...child,
                _section: { title: item.Question, color: item.Color },
            }))
    })
    return out
}

export default buildNavItems
